module.exports = __webpack_public_path__ + "img/pdf.6283e8b9.svg";